// extracted by mini-css-extract-plugin
export const sectionTwoColTile = "twoColTile-module--sectionTwoColTile--1wxz2";
export const minimalMargin = "twoColTile-module--minimalMargin--3NItL";
export const sectionContainer = "twoColTile-module--sectionContainer--1c7WL";
export const row = "twoColTile-module--row--9sfAZ";
export const col = "twoColTile-module--col--19mbo";
export const imageWrapper = "twoColTile-module--imageWrapper--1O95X";
export const bgWrap = "twoColTile-module--bgWrap--1UAMf";
export const ctaWrap = "twoColTile-module--ctaWrap--E7PQE";
export const cta = "twoColTile-module--cta--2go48";
export const richtext = "twoColTile-module--richtext--2K6yX";
export const contentCta = "twoColTile-module--contentCta--2WU4T";
export const primaryCTA = "twoColTile-module--primaryCTA--232Iv";
export const secondaryCTA = "twoColTile-module--secondaryCTA--2O9GB";
export const tertiaryCTA = "twoColTile-module--tertiaryCTA--OUmb7";
export const playButton = "twoColTile-module--playButton--3V2Zs";